import { render, staticRenderFns } from "./DimplexLogo.vue?vue&type=template&id=4556ebef&scoped=true&"
var script = {}
import style0 from "./DimplexLogo.vue?vue&type=style&index=0&id=4556ebef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4556ebef",
  null
  
)

export default component.exports